// extracted by mini-css-extract-plugin
export var icon = "_4a-1";
export var subtext = "_4a-0";